<template>
  <div>
    <el-alert
      title="草稿可接受或拒绝。已接受且尚未生成到货时，按明细生成采购到货草稿，仓库优先选用名称含原料、组件或材料的启用仓。到货单仍需在采购到货里入库确认。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.offerCode" clearable placeholder="报价单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.supplierName" clearable placeholder="供应商" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.offerState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已接受" value="01" />
        <el-option label="已拒绝" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="offerCode" label="报价单号" width="190" />
      <el-table-column prop="offerName" label="名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="supplierName" label="供应商" min-width="140" show-overflow-tooltip />
      <el-table-column prop="offerDate" label="报价日期" width="120" />
      <el-table-column prop="desiredDate" label="期望到货" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="stateType(row.offerState)">{{ stateLabel(row.offerState) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="arrivalCode" label="采购到货单" width="180" show-overflow-tooltip />
      <el-table-column label="操作" width="300" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" :disabled="row.offerState !== '00'" @click="openEdit(row.offerId)">修改</el-button>
          <el-button type="text" @click="openEdit(row.offerId, true)">查看</el-button>
          <el-button type="text" :disabled="row.offerState !== '00'" @click="acceptRow(row.offerId)">接受</el-button>
          <el-button type="text" :disabled="(row.offerState !== '00' && row.offerState !== '01') || !!row.arrivalId" @click="declineRow(row.offerId)">拒绝</el-button>
          <el-button type="text" :disabled="row.offerState !== '01' || !!row.arrivalId" @click="createDelivery(row.offerId)">生成到货</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.offerState !== '00'" @click="onDelete(row.offerId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="980px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="报价单号"><el-input v-model="form.offerCode" placeholder="留空自动生成" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称"><el-input v-model="form.offerName" placeholder="可选" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商" required>
              <el-select v-model="form.supplierId" filterable clearable placeholder="请选择供应商" style="width:100%">
                <el-option v-for="c in companies" :key="c.companyId" :label="(c.companyNumber ? c.companyNumber + ' / ' : '') + c.companyName" :value="c.companyId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报价日期">
              <el-date-picker v-model="form.offerDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望到货">
              <el-date-picker v-model="form.desiredDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
          </el-col>
        </el-row>
        <el-button v-if="!readonly" type="primary" size="mini" style="margin-bottom:8px" @click="addLine">添加物料</el-button>
        <el-table :data="form.lineList" border size="small">
          <el-table-column label="物料" min-width="240">
            <template slot-scope="{ row }">
              <el-select v-model="row.productId" filterable placeholder="选择物料" style="width:100%" :disabled="readonly">
                <el-option v-for="p in products" :key="p.productId" :label="(p.productNumber || '') + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="180">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.quantity" :min="0" :precision="5" style="width:100%" :disabled="readonly" />
            </template>
          </el-table-column>
          <el-table-column label="单价" width="180">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.pricePerUnit" :min="0" :precision="6" style="width:100%" :disabled="readonly" />
            </template>
          </el-table-column>
          <el-table-column label="金额" width="120">
            <template slot-scope="{ row }">{{ lineTotal(row) }}</template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" width="70" align="center">
            <template slot-scope="{ $index }"><el-button type="text" @click="form.lineList.splice($index, 1)">删除</el-button></template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listOffer, getOffer, saveOffer, updateOffer, deleteOffer,
  acceptOffer, declineOffer, createPurchaseDeliveryFromOffer
} from '../../api/offer'
import { selectProduct } from '../../api/product'
import { selectCompany } from '../../api/staff'

function emptyLine() {
  return { productId: '', quantity: 1, pricePerUnit: undefined }
}

function emptyForm() {
  return {
    offerId: '', offerCode: '', offerName: '', supplierId: '',
    offerDate: null, desiredDate: null, remark: '', lineList: [emptyLine()]
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { offerCode: '', supplierName: '', offerState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, readonly: false,
      form: emptyForm(),
      products: [], companies: []
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看报价'
      return this.form.offerId ? '修改报价' : '新增报价'
    }
  },
  created() {
    this.load()
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
    selectCompany().then(res => { this.companies = res.data || [] }).catch(() => {})
  },
  methods: {
    stateLabel(s) { return s === '01' ? '已接受' : s === '02' ? '已拒绝' : '草稿' },
    stateType(s) { return s === '01' ? 'success' : s === '02' ? 'danger' : 'info' },
    lineTotal(row) {
      if (row.pricePerUnit == null || row.quantity == null) return ''
      return (Number(row.pricePerUnit) * Number(row.quantity)).toFixed(6)
    },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listOffer({
        currentPage: this.page, pageSize: this.pageSize,
        offerCode: this.query.offerCode,
        supplierName: this.query.supplierName,
        offerState: this.query.offerState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    addLine() { this.form.lineList.push(emptyLine()) },
    openEdit(id, readonly) {
      this.readonly = !!readonly
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getOffer(id).then(res => {
        const d = res.data || {}
        this.form = {
          offerId: d.offerId,
          offerCode: d.offerCode,
          offerName: d.offerName,
          supplierId: d.supplierId || '',
          offerDate: d.offerDate || null,
          desiredDate: d.desiredDate || null,
          remark: d.remark,
          lineList: (d.lineList && d.lineList.length) ? d.lineList.map(l => ({
            productId: l.productId,
            quantity: l.quantity == null ? undefined : Number(l.quantity),
            pricePerUnit: l.pricePerUnit == null ? undefined : Number(l.pricePerUnit)
          })) : [emptyLine()]
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.supplierId) {
        this.$message.warning('请选择供应商')
        return
      }
      const lineList = (this.form.lineList || []).filter(l => l.productId && Number(l.quantity) > 0)
      if (!lineList.length) {
        this.$message.warning('请添加报价明细')
        return
      }
      this.saving = true
      const payload = {
        offerId: this.form.offerId || undefined,
        offerCode: this.form.offerCode || undefined,
        offerName: this.form.offerName || undefined,
        supplierId: this.form.supplierId,
        offerDate: this.form.offerDate || null,
        desiredDate: this.form.desiredDate || null,
        remark: this.form.remark,
        lineList: lineList.map(l => ({
          productId: l.productId,
          quantity: l.quantity,
          pricePerUnit: l.pricePerUnit == null ? null : l.pricePerUnit
        }))
      }
      const req = this.form.offerId ? updateOffer(payload) : saveOffer(payload)
      req.then(() => {
        this.$message.success('已保存')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    acceptRow(id) {
      this.$confirm('确认接受该报价?', '提示', { type: 'warning' }).then(() => {
        acceptOffer(id).then(() => { this.$message.success('已接受'); this.load() })
      }).catch(() => {})
    },
    declineRow(id) {
      this.$confirm('确认拒绝该报价?', '提示', { type: 'warning' }).then(() => {
        declineOffer(id).then(() => { this.$message.success('已拒绝'); this.load() })
      }).catch(() => {})
    },
    createDelivery(id) {
      this.$confirm('将按报价明细生成采购到货草稿，确认继续?', '提示', { type: 'warning' }).then(() => {
        createPurchaseDeliveryFromOffer(id).then(res => {
          const code = (res.data && res.data.arrivalCode) || ''
          this.$message.success('已生成到货单 ' + code)
          this.load()
        })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteOffer([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
